import React from "react";
import { useChartData } from "./UserChartData";
import { dashboardChartProps } from "../../core/dto/dashboard.dto";
import LineChartWidget from "./LineChartWidget";

const CallForwardBarChart = ({ apiEndpoint, startDate, endDate, selectedLocation, selectedAgent, onChartLoaded }: dashboardChartProps) => {
    const payload = {
        from_date: startDate ? startDate.toLocaleDateString("en-CA") : null,
        to_date: endDate ? endDate.toLocaleDateString("en-CA") : null,
        location_id: selectedLocation,
        agent_id: selectedAgent,
        call_direction: "call forwarded",
        clientTZ: Intl.DateTimeFormat().resolvedOptions().timeZone,
    };

    const chartData = useChartData(apiEndpoint, payload, onChartLoaded);

    return <LineChartWidget title="Forwarded Calls" chartData={chartData} />;
};

export default CallForwardBarChart;
